import { DETAILED, SLUGS } from "@components/home/routes";
import MainWrapper from "@components/pages/common/MainWrapper";
import TCDetailsLayout from "@components/pages/travel-consultant/components/TCDetailsLayout";
import {
  JSON_SCHEMAS,
  RAQ_FORM_TYPES,
  RAQ_PAGE_TYPE,
} from "@components/utils/constants";
import { handleResponseCode } from "@components/utils/getStaticPropsHelpers";
import { sanitizeTravelConsultant } from "@components/utils/sanitizeHelpers";
import JsonLdSchema from "@libs/schema/JsonLdSchema";
import fetchGet from "@services/api/fetchGet";
import baseApiCalls from "@services/baseApiCalls";
import detectRedirect from "@services/detectRedirect";
import { GetStaticPaths, GetStaticProps } from "next";
import { useRouter } from "next/router";
import { ITravelConsultantDetailsPage } from "../../../types/commonResponses";
import { PAGE_TYPES } from "../../../types/index";
import { ITravelConsultantResponse } from "../../../types/modelResponses";

const TCDetail = (props: ITravelConsultantDetailsPage): JSX.Element => {
  const travelConsultant = sanitizeTravelConsultant(props.travelConsultant);
  const router = useRouter();

  return (
    <MainWrapper>
      <JsonLdSchema
        data={{
          breadcrumbObjects: undefined,
          schema: undefined,
          content: { ...props.travelConsultant, url: router.asPath },
        }}
        type={JSON_SCHEMAS.PERSON}
      />
      <TCDetailsLayout
        raqFormProps={{
          topNavigation: props.topNavigation,
          raqFormType: props.raqFormType,
          pageType: RAQ_PAGE_TYPE.TRAVEL_CONSULTANT,
        }}
        travelConsultant={travelConsultant}
      />
    </MainWrapper>
  );
};

export default TCDetail;

export const getStaticPaths: GetStaticPaths = async () => {
  const res = await fetchGet(SLUGS.TCS);
  const travelConsultants = await res.json();

  const paths = travelConsultants.map(
    (e: Pick<ITravelConsultantResponse, "SEO">) => ({
      params: { slug: e?.SEO?.Slug.split("/") },
    })
  );
  return { paths, fallback: "blocking" };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const redirect = await detectRedirect(
    `our-travel-agency/planners/${params?.slug?.[0]}`
  );
  if (redirect) {
    return redirect;
  }

  const travelConsultantData = await fetchGet(
    `${DETAILED.TCS}${
      Array.isArray(params?.slug) ? params?.slug.join("@") : ""
    }`
  );

  const { pageNotFound, hasInternalError } =
    handleResponseCode(travelConsultantData);

  if (pageNotFound) {
    return {
      notFound: true,
      revalidate: Number(process.env.REVALIDATE_TIMER),
    };
  }
  const travelConsultant = hasInternalError
    ? null
    : await travelConsultantData.json();

  //const raqFormData = await fetchGet(RAQ_FORM);
  //const raqForm = await raqFormData.json();

  const {
    footer,
    mediaAssets,
    searchManagementRes,
    topNavigation,
    menus,
    usp,
  } = await baseApiCalls();

  const pageType = hasInternalError
    ? PAGE_TYPES.InternalErrorPage
    : PAGE_TYPES.TravelConsultant;
  return {
    props: {
      footer,
      mediaAssets,
      topNavigation,
      travelConsultant,
      pageType,
      //raqFormType: raqForm?.Form_Type || RAQ_FORM_TYPES.FORM_A,
      raqFormType: RAQ_FORM_TYPES.FORM_B,
      menus,
      usp,
      searchManagement: searchManagementRes,
      hasInternalError,
    },
    revalidate: Number(process.env.REVALIDATE_TIMER),
  };
};
